import jwtDecode    from 'jwt-decode';
import browserStore from 'store';

import { LOGOUT } from '../constants/actionTypes';
import login from './login';
import logout from './logout';

export {
    authenticate,
    login,
    logout
};


function authenticate() {
    return dispatch => {
        try {
            let jwt = browserStore.get('token');
            if (jwt) {
                jwtDecode(jwt); // Is token valid?
                let sessionData = browserStore.get('sessionData');
                dispatch(login.success(jwt, sessionData));
            }
        } catch (e) {
            dispatch({
                type: LOGOUT
            });
        }
    };
}